import { initNavigationData } from '@/utils/store/userRoles/userRolesListNavigation';
import { UserRolesState } from './types';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export { namespace } from './types';

export const state: UserRolesState = {
  featuresPermissions: [],
  roles: {
    userRolesListComponentsState: {
      loading: {
        userRolesList: false
      },
      error: {
        userRolesList: false
      },
      fetched: {
        userRolesList: false
      }
    },
    userRoles: {
      userRolesList: [],
      navigation: initNavigationData,
      total: 0
    }
  },
  rolePermissions: {
    displayName: '',
    id: '',
    permissions: [
    ]
  },
  editing: false,
  notification: {
    content: '',
    status: '',
    isOpen: false,
    type: ''
  },
  error: undefined,
  addition: false,
  selected: undefined
};

const namespaced = true;

export const module = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
